import { useState } from 'react'

import { Space } from 'app/common/templates-next/report-template'

import { Filters } from './ReportFilter'
import { Report } from './Report'

export const GroupedSubsidies = () => {
  const [reportID, setReportID] = useState<null | string>(null)
  return (
    <>
      <Filters onReportId={setReportID} />
      <Space />
      <Report reportID={reportID} onReportId={setReportID} />
    </>
  )
}

